export default __webpack_public_path__ + "static/media/xls.e3d99362.svg";